module.exports = __webpack_public_path__ + "static/media/add quiz.6b1a65c5.svg";